import * as e from "react";
import { forwardRef as l } from "react";
const a = l(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 18 19",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#prefix__clip0_8218_966)" }, /* @__PURE__ */ e.createElement("rect", { fill: "#089B80", height: 18, rx: 9, width: 18, y: 1 }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9 3L10.5933 7.78069H15.75L11.578 10.7355L13.1714 15.5162L9 12.5614L4.82864 15.5162L6.42195 10.7349L2.25 7.78125H7.40668L9 3Z",
        fill: "#fff"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "prefix__clip0_8218_966" }, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 19, width: 18 })))
  );
});
export {
  a as MarketStatusWon
};
